import quickfeedback from './quickfeedback.js'

const navLinkSelector = '.nav-link';
const navLinkWrapperSelector = '.nav-link-wrapper';
const navParentSelector = '.nav-parent';
const navLinkIconSelector = '.nav-link-icon';
const activeClass = 'active';
const mainTocClass = 'main-toc';
const activeLinkSelector = `.${activeClass}`;
const initActiveLinkSelector = `.nav-parent .${activeClass}`;
const mainToc = document.querySelector(`.${mainTocClass}`);
const mainContent = document.querySelector('.main');
const topicHeading = document.querySelector('.topic-heading');
const modifiedTime = document.querySelector('.modified-time > time');
const breadcrumbs = document.querySelector('.breadcrumbs');
const contentTile = document.querySelector('.tile.content');
const inPageTocTile = document.querySelector('.in-page-toc-tile');
const siteLoader = document.querySelector('.site-loader-modal');
const dataFetchedAttribute = 'data-fetched';
const expandedClass = 'expanded';
const collapsedClass = 'collapsed';
let fetchingPageData = false;
let siteLoaderTimeout;
const loadAsync = document.querySelector('.site-container[data-load-async]') !== null;
const navSlug = document.querySelector('meta[name="cv-nav-slug"]');
const oemSlug = document.querySelector('meta[name="cv-oem-slug"]');
const majorVersion = document.querySelector('meta[name="cv-major-version"]');
const minorVersion = document.querySelector('meta[name="cv-minor-version"]');

function mainTocIsDisabled(){
    try{
        return mainToc.classList.contains('disabled');
    } catch(err){
        console.log(err);
    }
}

function topicApi(url){
    const filename = url.substring(url.lastIndexOf('/')+1);
    const filenameNoExt = filename.substring(0, filename.lastIndexOf('.'));
    return `/api/topic?version=${majorVersion.getAttribute('content')}.${minorVersion.getAttribute('content')}&oem=${oemSlug.getAttribute('content')}&nav=${navSlug.getAttribute('content')}&filename=${filenameNoExt}`;
}


function navChildrenApi(url){
    const filename = url.substring(url.lastIndexOf('/')+1);
    const filenameNoExt = filename.substring(0, filename.lastIndexOf('.'));
    return `/api/nav?version=${majorVersion.getAttribute('content')}.${minorVersion.getAttribute('content')}&oem=${oemSlug.getAttribute('content')}&nav=${navSlug.getAttribute('content')}&filename=${filenameNoExt}`;
}


function scrollNavToActive(){
    try {
        if (mainTocIsDisabled()){
            return;
        }
        const activeNavLink = mainToc.querySelector(initActiveLinkSelector);
        if (!activeNavLink) {
            console.log('no active nav link found to scroll to');
            return;
        }
        let top = activeNavLink.offsetTop - mainToc.offsetTop -8;
        if (top < 0){
            top = 0;
        }
        mainToc.scroll({top: top, left: 0, behavior: 'smooth'});
        console.log(`scroll ${top}`);
    } catch (err) {
        console.log(`scrolling err ${err}`);
    }
}


function scrollMainToActive(href){
    let top = 0;
    try {
        if (href && href.split('#').length > 1) {
            const hash = href.split('#')[href.split('#').length - 1];
            top = mainContent.querySelector(`#${href}`).offsetTop - mainContent.offsetTop;
        } else if (window.location.hash.length > 0) {
            top = mainContent.querySelector(window.location.hash).offsetTop - mainContent.offsetTop;
        }
    } catch (err) {
        console.log(`scrolling error: ${err}`)
    }
    mainContent.scroll({top: top, left:0, behavior: 'smooth'});
}

function populateTopicData(href, data){
    document.title = data.title;
    topicHeading.innerHTML = data.title;
    inPageTocTile.innerHTML = data.inPageToc;
    modifiedTime.setAttribute('datetime', data.datetime);
    modifiedTime.innerHTML = data.modifiedTime;
    breadcrumbs.innerHTML = data.breadcrumbs;
    contentTile.innerHTML = data.content;
    try{
        quickfeedback.reset();
    } catch (err){
        console.error('unable to reset quickfeedback');
    }
}

function populateNavData(evt, navLink, data) {
    if (data.navChildren.length === 0) {
        return;
    }
    const navLinkWrapper = navLink.closest(navLinkWrapperSelector);
    const navLinkIcon = navLinkWrapper.querySelector(navLinkIconSelector);
    const navParent = navLink.closest(navParentSelector);
    const dataFetched = navParent.getAttribute(dataFetchedAttribute);
    if (dataFetched === 'false'){
        navParent.querySelector('ul').innerHTML = data.navChildren;
        navParent.setAttribute(dataFetchedAttribute, 'true');
    }
    if (evt.type !== 'popstate'){
        setTimeout(() => {
            navParent.classList.toggle(collapsedClass);
            navParent.classList.toggle(expandedClass);
        }, 100);
    }

}

function clickNavIconHandler(e){
    const navIcon = e.target.closest(navLinkIconSelector);
    if (navIcon){
        if (fetchingPageData){
            return;
        }
        const navLink = navIcon.previousElementSibling;
        const href = navLink.getAttribute('href');
        const navChildrenUrl = navChildrenApi(href);
        const absoluteURL = navLink.href;
        console.log(`fetching ${navChildrenUrl}`);
        fetchingPageData = true;
        fetch(navChildrenUrl)
            .then(response => processResponse(response, {absoluteURL}))
            .then(data => {
                fetchingPageData = false;
                populateNavData(e, navLink, data);
            })
            .catch( err => {
                console.log(`error getting page data ${err}`);
                fetchingPageData = false;
            });
    }
}

function toggleActiveLink(navLink){
    try{
        const activeNavLink = mainToc.querySelector(activeLinkSelector);
        activeNavLink.classList.remove(activeClass);
    } catch (err) {
        console.log(err);
    }

    navLink.closest('li').classList.add(activeClass);
}

function clickNavLinkHandler(e) {
    const navLink = e.target.closest(navLinkSelector);
    try{
        loadTopic(e, navLink);
    } catch (err) {
        console.log(err);
    }

}

function loadTopic(evt, navLink){
    if (navLink){
        evt.preventDefault();
        if (fetchingPageData){
            return;
        }
        siteLoaderTimeout = setTimeout( () => {siteLoader.classList.add('show')}, 1000);
        const href = navLink.getAttribute('href');
        const topicUrl = topicApi(href);
        const absoluteURL = navLink.href;
        console.log(`fetching ${topicUrl}`);
        fetchingPageData = true;
        toggleActiveLink(navLink);
        fetch(topicUrl)
            .then(response => processResponse(response, {absoluteURL}))
            .then(data => {
                if (evt.type !== 'popstate'){
                    history.pushState({}, '', href);
                }
                fetchingPageData = false;
                populateTopicData(href, data);
                populateNavData(evt, navLink, data);
                clearTimeout(siteLoaderTimeout);
                siteLoader.classList.remove('show');
                scrollMainToActive(href);
            })
            .catch( err => {
                console.log(`error getting page data ${err}`);
                fetchingPageData = false;
                clearTimeout(siteLoaderTimeout);
                siteLoader.classList.remove('show');
            });
    }
}

async function processResponse(response, navInfo){
    if(response.status === 401){
        redirectTo(navInfo.absoluteURL);
        throw Error(await response.text())
    }
    return response.json()
}

function redirectTo(url){
    window.location = url;
}

function navHandler(e){
    if (loadAsync){
        clickNavLinkHandler(e);
    }
    clickNavIconHandler(e);
}

function backHandler(e) {
    const navLinkSelector = `[href="${window.location.pathname}"]`;
    const navLink = mainToc.querySelector(navLinkSelector);
    // if there is no navlink or if the navlink is not visible
    if (!navLink || navLink.parentElement.offsetHeight === 0){
        window.location = window.location.href;
        return;
    }
    loadTopic(e, navLink);
    scrollNavToActive();
}

export default {navHandler, backHandler, scrollNavToActive, scrollMainToActive};